/* ============ SHIMCO THEME JS ============ */
(function(){
  "use strict";
  var routes = window.routes || {};
  var THRESHOLD = parseInt((window.shimcoConfig && window.shimcoConfig.freeShipping) || 1500, 10) * 100; // en centavos

  function money(cents){
    var n = (cents/100);
    return '$' + n.toLocaleString('es-MX', {minimumFractionDigits: (n % 1 ? 2 : 0), maximumFractionDigits:2});
  }

  /* ---------- TOAST ---------- */
  var toastTimer;
  function toast(msg){
    var t = document.getElementById('toast');
    if(!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2400);
  }
  window.shimcoToast = toast;

  /* ---------- DRAWER ---------- */
  function openDrawer(){ var d=document.getElementById('CartDrawer'),b=document.getElementById('CartDrawerBg'); if(d){d.classList.add('open');} if(b){b.classList.add('open');} }
  function closeDrawer(){ var d=document.getElementById('CartDrawer'),b=document.getElementById('CartDrawerBg'); if(d){d.classList.remove('open');} if(b){b.classList.remove('open');} }
  window.shimcoOpenCart = openDrawer;
  window.shimcoCloseCart = closeDrawer;

  function openMenu(){ var d=document.getElementById('MobileMenu'),b=document.getElementById('MobileMenuBg'); if(d){d.classList.add('open');} if(b){b.classList.add('open');} }
  function closeMenu(){ var d=document.getElementById('MobileMenu'),b=document.getElementById('MobileMenuBg'); if(d){d.classList.remove('open');} if(b){b.classList.remove('open');} }

  /* ---------- RENDER CART ---------- */
  function renderCart(cart){
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
    var totalEl = document.getElementById('CartDrawerTotal');
    if(totalEl) totalEl.textContent = money(cart.total_price);

    var box = document.getElementById('CartDrawerItems');
    if(box){
      if(!cart.items.length){
        box.innerHTML = '<div class="drawer-empty">Tu carrito está vacío.<br>Descubre nuestras piezas ✨</div>';
      } else {
        box.innerHTML = cart.items.map(function(i){
          var imgSrc = i.image ? i.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1$2') : '';
          var img = i.image ? '<a href="'+i.url+'" class="ci-imglink"><img class="ci-img" src="'+imgSrc+'" alt=""></a>' : '<div class="ci-img"></div>';
          var priceHtml;
          if(i.original_line_price > i.final_line_price){
            priceHtml = '<div class="ci-price"><small>'+money(i.original_line_price)+'</small>'+money(i.final_line_price)+'</div>';
          } else {
            priceHtml = '<div class="ci-price">'+money(i.final_line_price)+'</div>';
          }
          var disc = '';
          if(i.line_level_discount_allocations && i.line_level_discount_allocations.length){
            disc = i.line_level_discount_allocations.map(function(d){
              return '<span class="ci-disc">🎀 '+d.discount_application.title+' (−'+money(d.amount)+')</span>';
            }).join('');
          }
          return '<div class="ci">'+img+
            '<div class="ci-info"><span class="ci-cat">'+(i.product_type||'')+'</span>'+
            '<h5><a href="'+i.url+'">'+i.product_title+'</a></h5>'+ disc +
            '<div class="ci-qty"><button data-change="'+i.key+'" data-qty="'+(i.quantity-1)+'" aria-label="menos">−</button>'+
            '<span>'+i.quantity+'</span>'+
            '<button data-change="'+i.key+'" data-qty="'+(i.quantity+1)+'" aria-label="más">+</button></div>'+
            '<button class="ci-rm" data-change="'+i.key+'" data-qty="0">Quitar</button></div>'+
            priceHtml + '</div>';
        }).join('');
      }
    }

    var summary = document.getElementById('CartDrawerSummary');
    if(summary){
      var rows = '';
      if(cart.items.length){
        rows += '<div class="sum-row"><span>Subtotal</span><span>'+money(cart.items_subtotal_price)+'</span></div>';
        if(cart.cart_level_discount_applications && cart.cart_level_discount_applications.length){
          cart.cart_level_discount_applications.forEach(function(d){
            rows += '<div class="sum-row disc"><span>🎀 '+d.title+'</span><span>−'+money(d.total_allocated_amount)+'</span></div>';
          });
        } else if(cart.total_discount > 0){
          rows += '<div class="sum-row disc"><span>🎀 Descuento</span><span>−'+money(cart.total_discount)+'</span></div>';
        }
      }
      summary.innerHTML = rows;
    }

    var note = document.getElementById('CartDrawerNote');
    if(note){
      if(!cart.items.length){ note.textContent = 'Envío gratis en pedidos desde '+money(THRESHOLD)+' 🤍'; }
      else if(cart.total_price >= THRESHOLD){ note.textContent = '¡Tu envío es gratis! 🤍'; }
      else { note.textContent = 'Te faltan '+money(THRESHOLD - cart.total_price)+' para envío gratis 💕'; }
    }
    var bar = document.getElementById('CartDrawerBar');
    if(bar){
      var pct = cart.items.length ? Math.min(100, Math.round(cart.total_price / THRESHOLD * 100)) : 0;
      bar.style.width = pct + '%';
    }
  }

  function fetchCart(){
    return fetch(routes.cart_url + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ renderCart(c); return c; });
  }

  function addToCart(id, qty){
    return fetch(routes.cart_add_url + '.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function(r){ return r.json(); })
      .then(function(item){ return fetchCart().then(function(c){ openDrawer(); return item; }); });
  }

  function changeCart(key, qty){
    return fetch(routes.cart_change_url + '.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(function(c){ renderCart(c); return c; });
  }

  /* ---------- EVENTOS GLOBALES ---------- */
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-open-cart]')){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-close-cart]')){ e.preventDefault(); closeDrawer(); return; }
    if(e.target.closest('[data-open-menu]')){ e.preventDefault(); openMenu(); return; }
    if(e.target.closest('[data-close-menu]')){ e.preventDefault(); closeMenu(); return; }

    var addBtn = e.target.closest('[data-add-id]');
    if(addBtn){
      e.preventDefault(); e.stopPropagation();
      var id = addBtn.getAttribute('data-add-id');
      addToCart(id,1).then(function(){ toast('Agregado a tu carrito 🤍'); });
      return;
    }

    var ch = e.target.closest('[data-change]');
    if(ch){ e.preventDefault(); changeCart(ch.getAttribute('data-change'), parseInt(ch.getAttribute('data-qty'),10)); return; }
  });

  /* ---------- FORM DE PRODUCTO ---------- */
  var pForm = document.getElementById('ProductForm');
  if(pForm){
    pForm.addEventListener('submit', function(e){
      e.preventDefault();
      var id = pForm.querySelector('[name="id"]').value;
      var qtyEl = pForm.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value,10) || 1 : 1;
      addToCart(id, qty).then(function(){ toast('Agregado a tu carrito 🤍'); });
    });
  }

  /* ---------- SELECTOR DE CANTIDAD ---------- */
  document.querySelectorAll('[data-qty-wrap]').forEach(function(w){
    var input = w.querySelector('input');
    w.querySelector('[data-qty-minus]').addEventListener('click', function(){ input.value = Math.max(1,(parseInt(input.value)||1)-1); });
    w.querySelector('[data-qty-plus]').addEventListener('click', function(){ input.value = (parseInt(input.value)||1)+1; });
  });

  /* ---------- SELECTOR DE VARIANTE (bloques) ---------- */
  document.querySelectorAll('[data-variant-select]').forEach(function(sel){
    sel.addEventListener('change', function(){
      var idInput = document.querySelector('[data-product-id]');
      if(idInput){ idInput.value = sel.value; }
    });
  });

  /* ---------- GALERÍA DE PRODUCTO ---------- */
  var main = document.getElementById('ProductMainImg');
  if(main){
    document.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        document.querySelectorAll('[data-thumb]').forEach(function(x){ x.removeAttribute('aria-current'); });
        t.setAttribute('aria-current','true');
        var src = t.getAttribute('data-full');
        main.innerHTML = '<img src="'+src+'" alt="">';
      });
    });
  }

  /* ---------- ACORDEONES (detalles + faq) ---------- */
  document.querySelectorAll('.det-q, .acc-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = q.parentElement, a = q.nextElementSibling;
      if(item.classList.contains('open')){ item.classList.remove('open'); a.style.maxHeight = null; }
      else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });
  window.addEventListener('load', function(){
    document.querySelectorAll('.det-item.open .det-a, .acc-item.open .acc-a').forEach(function(a){ a.style.maxHeight = a.scrollHeight + 'px'; });
  });

  /* ---------- REVEAL ON SCROLL ---------- */
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ---------- RECOMENDACIONES ---------- */
  var recBox = document.querySelector('[data-recommendations]');
  if(recBox && recBox.children.length === 0){
    var url = recBox.getAttribute('data-url');
    if(url){
      fetch(url).then(function(r){ return r.text(); }).then(function(html){
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if(fresh){ recBox.innerHTML = fresh.innerHTML; }
        document.querySelectorAll('[data-recommendations] .reveal').forEach(function(el){ el.classList.add('in'); });
      }).catch(function(){});
    }
  }

  /* ---------- NEWSLETTER POPUP ---------- */
  (function(){
    var pop = document.getElementById('NewsletterPopup');
    if(!pop) return;
    var KEY = 'shimco_news_popup_v3';
    var days = parseInt(pop.getAttribute('data-days'), 10) || 0;
    var delay = parseInt(pop.getAttribute('data-delay'), 10);
    if(isNaN(delay)) delay = 3000;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    function longSeen(){
      if(days === 0) return false;
      try{ var ts = parseInt(localStorage.getItem(KEY), 10); return ts && (Date.now() - ts) < days * 86400000; }
      catch(e){ return false; }
    }
    function sessionSeen(){ try{ return sessionStorage.getItem(KEY) === '1'; }catch(e){ return false; } }
    function rememberSession(){ try{ sessionStorage.setItem(KEY, '1'); }catch(e){} }
    function rememberLong(){ try{ localStorage.setItem(KEY, Date.now()); }catch(e){} }
    function open(){ pop.classList.add('open'); }
    function close(){ pop.classList.remove('open'); rememberSession(); }

    var success = pop.querySelector('.np-success');

    if(success){ rememberLong(); open(); }
    else if(designMode){ setTimeout(open, 400); }
    else if(!longSeen() && !sessionSeen()){ setTimeout(open, delay); }

    pop.addEventListener('click', function(e){
      if(e.target === pop || e.target.closest('[data-np-close]')){ close(); }
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && pop.classList.contains('open')){ close(); } });
    var submitBtn = pop.querySelector('[data-np-submit]');
    if(submitBtn){ submitBtn.addEventListener('click', rememberLong); }

    var copyBtn = pop.querySelector('[data-np-copy]');
    if(copyBtn){
      copyBtn.addEventListener('click', function(){
        var code = copyBtn.getAttribute('data-code') || '';
        var done = function(){ copyBtn.textContent = '¡Copiado!'; copyBtn.classList.add('copied'); setTimeout(function(){ copyBtn.textContent = 'Copiar'; copyBtn.classList.remove('copied'); }, 2000); };
        if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var t = document.getElementById('npCode');
          if(t){ var r = document.createRange(); r.selectNode(t); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); try{ document.execCommand('copy'); }catch(e){} s.removeAllRanges(); }
          done();
        }
      });
    }
  })();

  /* ---------- INIT ---------- */
  fetchCart();
})();
